import { PageLayout } from "@/components/layout/PageLayout";
import { Helmet } from "react-helmet-async";
import { TokenSniper } from "@/components/sniper/TokenSniper";
import { Crosshair, AlertTriangle, Zap, Shield, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Sniper() {
  return (
    <>
      <Helmet>
        <title>Token Sniper - TheMoonRun</title>
        <meta name="description" content="Snipe new token launches on Solana. Auto-buy with filters, anti-rug protection, and MEV protection." />
      </Helmet>
      
      <PageLayout>
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-red-500/20 to-orange-500/20 flex items-center justify-center">
              <Crosshair className="w-7 h-7 text-red-500" />
            </div>
            <div>
              <h1 className="text-2xl font-display font-bold text-foreground">Token Sniper</h1>
              <p className="text-muted-foreground">Auto-snipe new launches with smart filters</p>
            </div>
          </div>
          <Badge variant="outline" className="text-yellow-500 border-yellow-500/50">
            <AlertTriangle className="w-3 h-3 mr-1" />
            High Risk
          </Badge>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
          {[
            { icon: Zap, label: "Fast Execution", desc: "Sub-second snipes", color: "text-yellow-500" },
            { icon: Shield, label: "Anti-Rug", desc: "Protection enabled", color: "text-green-500" },
            { icon: Clock, label: "Auto-Sell", desc: "TP/SL triggers", color: "text-blue-500" },
            { icon: Crosshair, label: "Smart Filters", desc: "MC & Liquidity", color: "text-red-500" },
          ].map((feature, i) => (
            <div key={i} className="p-3 sm:p-4 rounded-xl bg-card border border-border">
              <feature.icon className={`w-5 h-5 ${feature.color} mb-2`} />
              <p className="text-sm font-semibold text-foreground">{feature.label}</p>
              <p className="text-xs text-muted-foreground">{feature.desc}</p>
            </div>
          ))}
        </div>

        <TokenSniper />
      </PageLayout>
    </>
  );
}
